import Dialog from '../../1. Core/Controls/Dialog/Dialog';
import DataTable from '../../1. Core/Controls/DataTable/DataTable';
import {ServerAPI} from '../../1. Core/ServerAPI';
import UserInfo, {IUserInfo} from '../../1. Core/UserInfo';
import NP from '../../1. Core/NP';
import Menu from '../../1. Core/Controls/Menu/Menu';
import ListItem from '../../1. Core/Controls/ListBox/ListItem';

interface UserCollectionClaimRow {
	collectionId: number;
	packId: number | null;
	collectionName: string;
	packName: string;
	claimedAt: string;
}

interface UserCollectionClaimTableRow extends UserCollectionClaimRow {
	RewardType: string;
	RewardLabel: string;
}

export default class UserCollectionClaimsDialog {
	static formatClaimedAt(value: string): string {
		if (!value) {
			return '';
		}
		const date = new Date(value);
		return Number.isNaN(date.getTime()) ? value : date.toLocaleString();
	}

	static mapClaimRows(claims: UserCollectionClaimRow[]): UserCollectionClaimTableRow[] {
		return (claims || []).map((claim) => {
			const isSuperprize = claim.packId == null;
			return {
				...claim,
				collectionName: claim.collectionName || `#${claim.collectionId}`,
				RewardType: isSuperprize ? 'Superprize' : 'Pack',
				RewardLabel: isSuperprize
					? '—'
					: (claim.packName || `#${claim.packId}`),
				claimedAt: UserCollectionClaimsDialog.formatClaimedAt(claim.claimedAt),
			};
		});
	}

	static async show(user: IUserInfo) {
		const container = document.createElement('div');
		container.className = 'collection-claims-dlg__container';

		const table = new DataTable({
			Class: 'app-list--avatars mdc-data-table--margin data-table-battle',
			ParentNode: container,
			ShowPaginator: false,
			EnableSort: false,
			Height: 420,
			Width: 860,
			ShowSettingsButton: true,
			Columns: [{
				Content: 'Type',
				PropertyContent: 'RewardType',
				Width: '100px',
			}, {
				Content: 'Collection',
				PropertyContent: 'collectionName',
				Width: '30%',
			}, {
				Content: 'Pack',
				PropertyContent: 'RewardLabel',
				Width: '30%',
			}, {
				Content: 'Collection id',
				PropertyContent: 'collectionId',
				Width: '80px',
			}, {
				Content: 'Claimed at',
				PropertyContent: 'claimedAt',
				Width: '180px',
			}],
			EvItemContextMenu: async (s: object, e: { Event: Event, Item: UserCollectionClaimTableRow }) => {
				const item = e.Item;
				const menu = new Menu({
					Items: [{
						FontImage: NP.FontImages.delete,
						Content: 'Remove claim',
						Value: 'Remove',
					}],
					EvItemSelected: async (sender: Menu, args: { Item: ListItem }) => {
						if (args.Item.getValue() !== 'Remove') {
							return;
						}
						const isSuperprize = item.packId == null;
						const target = isSuperprize
							? `superprize #${item.collectionId}`
							: `pack #${item.packId}`;
						NP.showConfirm({
							Content: `Remove claim for ${target}? Reward will NOT be granted again automatically.`,
							EvOkButtonClick: async () => {
								const url = isSuperprize
									? `/fantasy/card-collections/admin/user/${user.Id}/superprize/${item.collectionId}`
									: `/fantasy/card-collections/admin/user/${user.Id}/pack/${item.packId}`;
								const ok = await ServerAPI.delet<boolean>(url);
								if (!ok) {
									NP.showMessage({ Content: 'Claim not found' });
									return;
								}
								await UserCollectionClaimsDialog.reload(table, user);
							},
						}).show();
					},
				});
				menu.showContextMenu(e.Event);
			},
		});

		const dlg = new Dialog({
			Caption: `Collection claims: ${UserInfo.getViewName(user)}`,
			ShowHeader: true,
			ShowButtons: false,
			Width: 900,
			Content: container,
		});
		dlg.show();

		await UserCollectionClaimsDialog.reload(table, user);
	}

	static async reload(table: DataTable, user: IUserInfo) {
		const claims = await ServerAPI.get<UserCollectionClaimRow[]>(
			`/fantasy/card-collections/admin/user/${user.Id}`,
		);
		table.setRows(UserCollectionClaimsDialog.mapClaimRows(claims));
	}
}
